import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { login as _login, logout as _logout, getMenu as _getMenu, getInfo as _getInfo, getUserMenu as _getUserMenu } from '@/api/user';
import { getToken, getPhone, getUserId, setToken, setPhone, setUserId, removeToken, removePhone, removeUserId, setSchoolId } from '@/utils/auth';
import * as AUTH from '@/utils/auth';
import { resetRouter } from '@/router';
var state = {
  token: getToken(),
  phone: getPhone(),
  user_id: getUserId(),
  school_id: '',
  school_name: '',
  name: '',
  menus: '',
  account_type: AUTH.getAccountType(),
  role: AUTH.getRole() ? AUTH.getRole().split(",") : [],
  roles: []
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_PHONE: function SET_PHONE(state, phone) {
    state.phone = phone;
  },
  SET_USERID: function SET_USERID(state, userid) {
    state.user_id = userid;
  },
  SET_MENUS: function SET_MENUS(state, menus) {
    state.menus = menus;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_SCHOOL_ID: function SET_SCHOOL_ID(state, school_id) {
    state.school_id = school_id;
  },
  SET_SCHOOL_NAME: function SET_SCHOOL_NAME(state, school_name) {
    state.school_name = school_name;
  },
  SET_ACCOUNT_TYPE: function SET_ACCOUNT_TYPE(state, account_type) {
    state.account_type = account_type;
  },
  SET_USER_ROLE: function SET_USER_ROLE(state, role) {
    state.role = role.split(",");
  },
  SET_ROLE: function SET_ROLE(state, roles) {
    console.log('enter SET_ROLE');
    state.roles = roles;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password;
    commit('SET_PHONE', username);
    setPhone(username);
    return new Promise(function (resolve, reject) {
      _login({
        phone: username.trim(),
        password: password,
        source: 'yj',
        token: ''
      }).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', data.token);
        commit('SET_USERID', data.user_id);
        commit('SET_SCHOOL_ID', data.school_id);
        commit('SET_ACCOUNT_TYPE', data.account_type);
        commit('SET_USER_ROLE', data.role);
        setToken(data.token);
        setPhone(data.phone);
        setUserId(data.user_id);
        setSchoolId(data.school_id);
        AUTH.setAccountType(data.account_type);
        AUTH.setRole(data.role);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loginSuc: function loginSuc(_ref2, data) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      commit('SET_PHONE', data.phone);
      commit('SET_TOKEN', data.token);
      commit('SET_USERID', data.user_id);
      commit('SET_SCHOOL_ID', data.school_id);
      commit('SET_ACCOUNT_TYPE', data.account_type);
      commit('SET_USER_ROLE', data.role);
      setToken(data.token);
      setPhone(data.phone);
      setUserId(data.user_id);
      setSchoolId(data.school_id);
      AUTH.setAccountType(data.account_type);
      AUTH.setRole(data.role);
      resolve();
    });
  },
  getMenu: function getMenu(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    console.log(state);
    return new Promise(function (resolve, reject) {
      _getMenu({
        phone: getPhone(),
        token: getToken()
      }).then(function (response) {
        console.log(response);
        var data = response.data;
        var roles = [];
        // for (const item of list) {
        //   roles.push(item.path)
        // }
        commit('SET_MENUS', roles);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      var params = {
        token: state.token,
        phone: state.phone
      };
      _getInfo(params).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var user_name = data.user_name,
          school_name = data.school_name,
          school_id = data.school_id;
        commit('SET_NAME', user_name);
        commit('SET_SCHOOL_NAME', school_name);
        commit('SET_SCHOOL_ID', school_id);
        commit('SET_SCHOOL_NAME', school_name);
        commit('SET_ACCOUNT_TYPE', data.account_type);
        commit('SET_USER_ROLE', data.role);
        setToken(data.token);
        setPhone(data.phone);
        setUserId(data.user_id);
        setSchoolId(data.school_id);
        AUTH.setAccountType(data.account_type);
        AUTH.setRole(data.role);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    return new Promise(function (resolve, reject) {
      _logout({
        token: getToken(),
        phone: getPhone()
      }).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_USERID', '');
        commit('SET_PHONE', '');
        commit('SET_SCHOOL_NAME', '');
        commit('SET_ACCOUNT_TYPE', "");
        removeToken();
        removePhone();
        removeUserId();
        AUTH.setAccountType("");
        AUTH.setRole("");
        resetRouter();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      removeToken();
      resolve();
    });
  },
  getUserMenu: function getUserMenu(_ref7) {
    var commit = _ref7.commit,
      state = _ref7.state;
    return new Promise(function (resolve, reject) {
      if (!state.token) {
        reject('登录失效，请重新登录！');
      }
      _getUserMenu({
        unit_id: state.school_id
      }).then(function (response) {
        var data = response.data,
          list = response.list;
        if (list.length === 0) {
          //reject('Verification failed, please Login again.')
        }
        var roles = [];
        var _iterator = _createForOfIteratorHelper(list),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            roles.push(item.path);
            if (item.path == "allScoreAuth") {
              //可查看全部成绩的话，则有下面这个页面的权限
              roles.push("ExchangeTranscripts");
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        commit('SET_ROLE', roles);
        resolve(roles);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};